import { html } from 'lit';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import { LightDomSlotFallbackController } from '../../lib/light-dom-slot-fallback/light-dom-slot-fallback-controller.js';
import { CrntButtonAlt } from '../button-alt/button-alt.component.js';
import styles from './tooltip-alternative-dialog.css.js';

class CrntTooltipAlternativeDialog extends CrntElement {
  constructor() {
    super(...arguments);
    this._lightDomSlotFallbackController = new LightDomSlotFallbackController(
      this,
      this._lightDomSlotFallbackControllerSlots
    );
  }
  static {
    this.dependencies = {
      [CrntButtonAlt.tagName]: CrntButtonAlt
    };
  }
  static {
    this.styles = trustedCSS(styles);
  }
  static {
    this.tagName = "crnt-tooltip-alternative-dialog";
  }
  get _lightDomSlotFallbackControllerSlots() {
    return [
      () => ({
        fallbackElement: () => {
          const slottedElement = this.querySelector("[slot='close-button-label']")?.cloneNode(true);
          const crntButton = document.createElement("crnt-button-alt");
          const button = document.createElement("button");
          crntButton.variant = "tertiary";
          crntButton.part = "close-button";
          if (slottedElement) {
            slottedElement.removeAttribute("slot");
            button.appendChild(slottedElement);
          } else {
            button.innerText = "Close";
          }
          crntButton.appendChild(button);
          return crntButton;
        },
        override: true,
        slotName: "_close-button"
      })
    ];
  }
  close() {
    this.shadowRoot?.querySelector("dialog")?.close();
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this._handleClick.bind(this));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("click", this._handleClick.bind(this));
  }
  render() {
    return html`
			<dialog part="dialog" closedby="any">
				<div part="header">
					<slot name="_close-button"></slot>
					<div autofocus part="title">
						<slot name="title"></slot>
					</div>
				</div>
				<div part="body"><slot @slotchange=${this._handleSlotChange}></slot></div>
			</dialog>

			<slot name="close-button-label" @slotchange=${this._handleSlotChange} hidden></slot>
		`;
  }
  showModal() {
    this.shadowRoot?.querySelector("dialog")?.showModal();
  }
  _handleClick(event) {
    const closeButton = this.querySelector('[part="close-button"] button');
    if (event.target.isEqualNode(closeButton)) {
      this.close();
    }
  }
  _handleSlotChange() {
    this._lightDomSlotFallbackController.setFallbackSlotsContent();
  }
}

export { CrntTooltipAlternativeDialog };
